import React, { useState, useEffect } from 'react';
import '../centerModal/css/centerModal.scss';
import { IoIosArrowDown } from '../../components/icons';
import { Modal, Form, FloatingLabel } from 'react-bootstrap';

import { useDispatch, useSelector } from 'react-redux';
import { otpVerifyForChange, changeSettings } from '../../Store/actions/profile.action';

import { getLocalStorage } from '../../common/common';
import { toast } from 'react-toastify';
import { getUserDetails, postMenu } from '../../Store/actions/commonActions';
import isdCodeJson from '../../common/data/isdCode.json';
export const PhoneUpdateModal = ({ show, onVerificationDone, onModalHide }) => {
  const dispatch = useDispatch();
  const [mobile, setMobile] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.mobile_primary : ''
  );

  const [mobileModalShow, setMobileModalShow] = useState(show);
  const [btnDisable, setBtnDisable] = useState(false);

  const [modalSlide, setModalSlide] = useState(1);
  const [isd, setIsd] = useState('+91');
  const [otp, setOtp] = useState('');

  useEffect(() => {
    setMobileModalShow(show);
  }, [show]);

  const fetchUserDetails = () => {
    // refetchUserDetails();
    dispatch(
      getUserDetails((res) => {
        if (res != 'error') {
          setMobile(res?.data?.mobile_primary ?? '');
          // setLocalStorage('user', res?.data);
        }
      })
    );
  };

  const otpMobVerification = () => {
    console.log('in verify');
    if (isd && mobile) {
      let formdata = new FormData();
      formdata.append('type', 'verify');
      formdata.append('mobile_no', mobile);
      formdata.append('isd', isd);
      formdata.append('otp', otp);
      setBtnDisable(true);
      dispatch(
        otpVerifyForChange(formdata, (res) => {
          if (res != 'error') {
            if (res.status_code == 200) {
              setMobile('');
              setIsd('+91');
              setOtp('');
              fetchUserDetails();
              setMobileModalShow(false);
              if (onVerificationDone) {
                onVerificationDone();
              }
              toast.success(`Mobile No Verified sucessfully`);
              // log('response', res);
            } else if (res.status_code == 203) {
              toast.error(res?.message);
            }
          }
          setBtnDisable(false);
        })
      );
    } else {
      toast.error('Please enter the OTP');
    }
  };
  const mobileVerification = () => {
    if (isd && mobile) {
      let regexMob = /^\d{10}$/;
      if (!mobile.match(regexMob)) {
        toast.error('Please Enter Mobile No in Correct Format');
      } else {
        let formdata = new FormData();
        formdata.append('type', 'mobile'); //'mobile', 'name', 'email', 'device'
        formdata.append('value', mobile); //for device value will be ""
        formdata.append('isd', isd);
        setBtnDisable(true);
        dispatch(
          changeSettings(formdata, (res) => {
            if (res != 'error') {
              if (res.status_code == 200) {
                toast.warning(`We Have Send a OTP on ${mobile} Please Enter`);
                setModalSlide(2);
              } else if (res.status_code == 203) {
                toast.error(res?.message);
              }
            }
            setBtnDisable(false);
          })
        );
      }
    } else {
      toast.error('Please fill the mandatory field');
    }
  };
  const onPhoneModalHide = () => {
    setMobileModalShow(false);
    if (onModalHide) {
      onModalHide();
    }
  };
  const onCancelClick = () => {
    setMobileModalShow(false);
    if (onModalHide) {
      onModalHide();
    }
  };

  const onKeyDownMobile = (e) => {
    if (e.key === 'Enter') {
      mobileVerification();
    }
  };

  const onKeyDownOtp = (e) => {
    if (e.key === 'Enter') {
      otpMobVerification();
    }
  };
  return (
    <Modal
      className="centerModal"
      size="md"
      centered
      show={mobileModalShow}
      onHide={onPhoneModalHide}
    >
      {modalSlide == 1 && (
        <>
          <Modal.Header className="position-relative p-4 border-0 mb-1">
            <Modal.Title className="fs-4 text-black fw-semibold">
              Please Enter Your Mobile
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <Form>
              <div className="w-100 centerModalFrm">
                <div className="cmnisdCodeParent mb-4">
                  <div className="cmnisdCodeSelect">
                    <select
                      onChange={(e) => {
                        setIsd(e.target.value);
                      }}
                      defaultChecked="+91"
                    >
                      {isdCodeJson.map((item, index) => (
                        <option name={item.name} value={item.value}>
                          {item.value}
                        </option>
                      ))}
                    </select>
                    <IoIosArrowDown customClass={'fs-16'} />
                  </div>
                  <FloatingLabel controlId="floatingInput" label="Enter Your Mobile No. *">
                    <Form.Control
                      className="fs-4"
                      type="text"
                      placeholder="Enter Your Mobile No."
                      value={mobile}
                      onKeyDown={onKeyDownMobile}
                      onChange={(e) => {
                        setMobile(e.target.value);
                      }}
                    />
                  </FloatingLabel>
                </div>

                <div className="d-flex flex-wrap centerModalBttns">
                  <button
                    className="col fs-4 btn btn-danger py-3 px-4"
                    type="button"
                    onClick={onPhoneModalHide}
                    aria-label="Cancel"
                  >
                    Cancel
                  </button>
                  <button
                    className="col fs-4 btn btn-primary py-3 px-4"
                    type="button"
                    onClick={mobileVerification}
                    disabled={btnDisable}
                    aria-label={btnDisable ? 'Submit' : 'Please Wait...'}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Form>
          </Modal.Body>
        </>
      )}
      {modalSlide == 2 && (
        <>
          <Modal.Header>
            <Modal.Title className="fs-4 text-black fw-semibold">
              Please Confirm Your OTP
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="w-100 centerModalFrm">
                <div className="row mt-n4">
                  <FloatingLabel
                    className="mt-4"
                    controlId="floatingInput"
                    label="Enter Your OTP *"
                  >
                    <Form.Control
                      className="fs-4"
                      type="text"
                      placeholder="Enter Your OTP"
                      value={otp}
                      onKeyDown={onKeyDownOtp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </FloatingLabel>

                  <div className="mt-4 d-flex flex-wrap centerModalBttns">
                    <button
                      className="col fs-4 btn btn-danger py-3 px-4"
                      type="button"
                      onClick={onPhoneModalHide}
                      aria-label="Cancel"
                    >
                      Cancel
                    </button>
                    <button
                      className="col fs-4 btn btn-primary py-3 px-4"
                      type="button"
                      onClick={otpMobVerification}
                      disabled={btnDisable}
                      aria-label={btnDisable ? 'Submit' : 'Please Wait...'}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </Modal.Body>
        </>
      )}
    </Modal>
  );
};

// export default memo(PhoneUpdateModal);
